<template>
  <div class="d-flex h-100 align-items-center justify-content-center">
    <img :src="getObjectThumbnail('course', course.organization_id, course.id, course.thumbnail)"
         class="img-fluid" alt="scenario">
    <a
      class="btn btn-primary font-weight-bold position-absolute"
      target="_blank"
      @click="startTimer"
      :href="launchData.activityLink">{{$t('app.website.visit')}}</a>
  </div>
</template>
<script>

import { mapGetters } from 'vuex';
import {
  SET_COURSE,
  FETCH_COURSES,
  FETCH_SIMPLE_ACTIVITY,
  SEND_ACTIVITY_TRACE,
} from '@/store/actions.type';
import store from '@/store';
import HelperMixin from '@/mixins/helperMixin';

export default {
  name: 'ExternalViewer',
  mixins: [HelperMixin],
  components: {
  },
  created() {
    this.loaded = false;
    this.watched = false;
    store.dispatch(FETCH_SIMPLE_ACTIVITY).then(() => {
      this.isLoading = false;
      this.$Progress.finish();
      this.initActivity();
    });
  },
  data() {
    return {
      loaded: false,
      videoPlayer: null,
      gameId: '',
      startTime: '',
      watched: false,
    };
  },
  watch: {
    $route() {
      this.loaded = false;
      this.watched = false;
      store.dispatch(FETCH_SIMPLE_ACTIVITY).then(() => {
        this.isLoading = false;
        this.$Progress.finish();
        this.initActivity();
      });
    },
  },
  computed: {
    ...mapGetters(['launchData', 'currentSession', 'course']),
  },
  methods: {
    postData() {
      if (!this.watched) return;
      const data = {
        currentPosition: 0,
        progress: 100,
        gameId: this.gameId,
        session_time: parseInt((Date.now() - this.startTime) / 1000, 10),
      };
      store.dispatch(SEND_ACTIVITY_TRACE, data).then(() => {
        store.dispatch(FETCH_COURSES).then(() => {
          store.dispatch(SET_COURSE, this.course.id).then(() => this.$Progress.finish());
        });
      }).catch(() => {
        this.$dialog.alert(this.$t('app.activity.commit.error'), {
          backdropClose: true,
          okText: this.$t('app.activity.commit.ok'),
        });
      });
    },
    startTimer() {
      this.watched = true;
      this.startTime = Date.now();
      this.postData();
    },
    initActivity() {
      const launchData = JSON.parse(this.launchData.launchData);
      this.gameId = launchData.gameId;
    },
  },
};
</script>
